module.exports = __webpack_public_path__ + "img/item_part_torque_sensor.8d7cd21b.png";